import React from "react";
import App from '../mainPages/index';

export default props => {
  if (typeof window === 'undefined') return null;
  return <App {...props} />
}
